"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProvenImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="246311" id="migration-insights-map" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(var(--primary)_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none" />
      
      {/* Glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`w-full max-w-5xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <p className="font-default text-xl md:text-2xl leading-relaxed text-foreground">
            <span className="font-semibold text-primary">Where Illinoisans moved (2024 Census):</span>{" "}
            Florida 11,659 &middot; Indiana 11,629 &middot; Wisconsin 9,914 &middot; Missouri 7,470 &middot; Tennessee 6,874
          </p>
          <p className="mt-4 text-sm text-muted-foreground">
            Source: U.S. Census Bureau ACS via Illinois Policy
          </p>
        </div>
      </div>
    </section>;
}